import permisos, { RESOURCE_CONVENIOS } from '@/auth/permissions/modules/convenios'
import { defineMenu } from '@/utils/menu'
import { ROUTE_CONFIGURACION_NIVEL_APROBACION, ROUTE_CONFIGURACION_TIPO_CONVENIO } from '@routes/convenios/names'

const { configuracion } = permisos

export default defineMenu([
    {
        title: 'convenios.subopciones.tipo_convenio',
        action: configuracion.tipoConvenio,
        resource: RESOURCE_CONVENIOS,
        route: ROUTE_CONFIGURACION_TIPO_CONVENIO,
    },
    {
        title: 'convenios.subopciones.nivel_aprobacion',
        action: configuracion.nivelAprobacion,
        resource: RESOURCE_CONVENIOS,
        route: ROUTE_CONFIGURACION_NIVEL_APROBACION,
    },
])
